import type {
  ProductFragment,
  ProductVariantFragment,
  SaleFragment,
} from "client/graphql/commerce-v2-api"

export function getProductVariantFromProduct(
  variantId?: string | null,
  product?: ProductFragment | null,
) {
  if (!product || !variantId) {
    return null
  }

  for (let i = 0; i < product.variants.length; i++) {
    if (product.variants[i].id === variantId) {
      return product.variants[i]
    }
  }

  return null
}

export function getProductVariantFromSale(
  variantId?: string | null,
  sale?: SaleFragment | null,
): ProductVariantFragment | null {
  if (!sale || !variantId) {
    return null
  }

  for (let i = 0; i < sale.products.length; i++) {
    const variant = getProductVariantFromProduct(
      variantId,
      sale.products[i],
    )

    if (variant) {
      return variant
    }
  }

  return null
}
